import { c as _c } from "react/compiler-runtime";
/**
 * @file ThemeServerBoundary.tsx
 * @description
 * -----------------------------------------------------
 * Ensures theme availability and consistency during Server Components rendering.
 * It bridges server-side theme resolution with client hydration,
 * preventing UI flashes, mismatches, and undefined theme states.
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2026-01-09
 * @author DLTCode
 * @author Adrián Anta
 * @copyright © DLTCode
 * @license Private
 * */

import { getUserTheme } from "../actions";
import { ThemeProviderInternal } from "./theme-provider-internal";
export async function ThemeProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = await getUserTheme();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const theme = t1;
  let t2;
  if ($[1] !== children) {
    t2 = <ThemeProviderInternal theme={theme}>{children}</ThemeProviderInternal>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}